import { OverflowMenu } from 'ui/actionMenu';
import { BUTTON_SIZES } from 'ui/button';
import { useRowOverflowMenu } from './hooks';
import { CellProps } from './types';
import { StyledTableCell } from './styles';

export const RowOverflowMenuCell = ({ row: list }: CellProps) => {
  const options = useRowOverflowMenu(list);
  return (
    <StyledTableCell>
      <OverflowMenu options={options} size={BUTTON_SIZES.LARGE} />
    </StyledTableCell>
  );
};
